// extracted by mini-css-extract-plugin
export default {"infoWrapper":"style_infoWrapper__EtZb6","infoTitle":"style_infoTitle__VQKSu","infoText":"style_infoText__Vjcz6","alertTitle":"style_alertTitle__mOXdo"};